import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, take } from 'rxjs';
import { GridColConfig, CustomgridOptions } from 'src/app/core/custom-grid/custom-grid';
import { CustomGridComponent } from 'src/app/core/custom-grid/custom-grid.component';
import { CustomOverlayMessaggeOptions } from 'src/app/core/custom-overlay-messagge/custom-overlay-messagge';
import { CustomOverlayMessaggeComponent } from 'src/app/core/custom-overlay-messagge/custom-overlay-messagge.component';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { environment } from 'src/environments/environment';
import { AdventureDto } from './partite-dto';
import { CardSummarySinglelineComponent } from "src/app/core/card-summary-singleline/card-summary-singleline.component";
import { GestionePartiteService } from './gestione-partite.service';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { ToastService } from 'src/app/core/toast/toast.service';


@Component({
  selector: 'app-gestione-partite',
  imports: [CardSummarySinglelineComponent, MatButtonModule, MatIconModule, MatMenuModule],
  templateUrl: './gestione-partite.component.html',
  styleUrl: './gestione-partite.component.scss'
})
export class GestionePartiteComponent implements OnInit, OnDestroy {

  options: GridColConfig[] = [];
  @ViewChild(CustomOverlayMessaggeComponent) overlayMessagge: CustomOverlayMessaggeComponent | undefined;


  partite: AdventureDto[] = [];

  private theEnd$ = new Subject<void>();


  constructor(
    private localstorage: LocalStorageService,
    private router: Router,
    private gameService: GestionePartiteService,
    private toast: ToastService
  ) {
  }



  ngOnInit(): void { //TODO make lazy loading


    this.localstorage.setTitolo('Avventure');

    this.gameService.getAll().pipe(take(1)).subscribe({
      next: (data: AdventureDto[]) => {
        this.partite = data;
      }
    })


    this.options = [
      {
        type: 'button',
        name: 'Modifica',
        field: 'none',
        icon: 'pencil',
        cssClass: 'edit-button',
        fieldOptions: {
        },
        width: '40'
      },
      {
        type: 'text',
        name: 'Nome',
        field: 'name',
        fieldOptions: {
        }
      },
      {
        type: 'text',
        name: 'Descrizione',
        field: 'description',
        fieldOptions: {
        }
      },
      {
        type: 'button',
        name: 'Elimina',
        field: 'none',
        icon: 'trash',
        cssClass: 'delete-button',
        fieldOptions: {
        },
        width: '40'
      }
    ];
  }

  ngOnDestroy(): void {
    this.theEnd$.next();
    this.theEnd$.complete();
  }


  btnClick(event: any) {
    if (event.action == 'modifica') {
      this.edit(event.data.id)
    }
    if (event.action == 'elimina') {

      this.overlayMessagge?.showDialog();
      this.overlayMessagge!.deleteItem = event.data.id;
    }

  }

  edit(id: string): void {
    this.router.navigate([`/home/partite/${id}`]);
  }


  add(): void {
    this.router.navigate([`/home/partite/new`]);
  }


  delete(id: string) {
    this.gameService.delete(id).pipe(take(1)).subscribe({
      next: () => {
        this.toast.success('Avventura eliminata');
        this.gameService.getAll().pipe(take(1)).subscribe({
          next: (data: AdventureDto[]) => {
            this.partite = data;
          }
        })
      }
    })
  }


}
